import Vue from 'vue';
import Vuex from 'vuex';

import DialogStore from './modules/dialog';
import LogStore from './modules/log';
import PopupStore from './modules/popup';
import FeedbackStore from './modules/feedback';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    dialogStore: DialogStore,
    logStore: LogStore,
    popupStore: PopupStore,
    feedbackStore: FeedbackStore,
  }
});
